import React from "react";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import makeStyles from "@mui/styles/makeStyles";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        control: {
            paddingLeft: spacing(1.5),
        },
    });
});
var Group = function (_a) {
    var children = _a.children, label = _a.label;
    var classes = useStyles();
    return (React.createElement("div", null,
        React.createElement(InputLabel, { shrink: true }, label),
        React.createElement(FormControl, { className: classes.control },
            React.createElement(FormGroup, null, children))));
};
export default Group;
//# sourceMappingURL=Group.js.map